import React from "react";
import { connect } from "react-redux";
import { compose, branch, renderComponent } from "recompose";
import { get } from "lodash";
import { Redirect } from "react-router-dom";

import { getDebtor, getDebtorTransferredTo } from "../../../modules/debtor";

const mapStateToProps = (
  state,
  {
    match: {
      params: { id }
    }
  }
) => ({
  loadedDebtorId: get(getDebtor(state), "id"),
  transferredTo: getDebtorTransferredTo(state),
  urlDebtorId: id
});

export const shouldRedirect = ({ loadedDebtorId, transferredTo, urlDebtorId }) =>
  loadedDebtorId === urlDebtorId &&
  !!transferredTo &&
  transferredTo !== urlDebtorId;

const withTransferRedirect = tab =>
  compose(
    connect(mapStateToProps),
    branch(
      shouldRedirect,
      renderComponent(({ transferredTo }) => (
        <Redirect
          to={{
            pathname: `/admin/debtors/${transferredTo}/${tab}`,
            state: { redirectedFromTransferred: true }
          }}
        />
      ))
    )
  );

export default withTransferRedirect;
